module.exports = "<div #baChartistChart class=\"ba-chartist-chart {{baChartistChartClass || ''}}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/src/app/theme/components/baChartistChart/baChartistChart.html
// module id = ../../../../../src/app/theme/components/baChartistChart/baChartistChart.html
// module chunks = 33